import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { TextMD } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { ChicletIndicator } from '../../screens/RoutineDetail/components/ChicletIndicator';
import { ExerciseImage } from '../ExerciseImage';
import { Spacing } from 'styleguide/spacing';
import { LinkableText } from 'components/LinkableText';
import { colors } from 'styleguide/colors';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

interface ExerciseCardProps {
  title: string;
  image?: string;
  notes?: string;
  sets?: string;
  reps?: string;
  timer?: string;
  style?: CSSProperties;
  supersetColor?: string;
}

export const ExerciseCard = ({
  title,
  image,
  notes,
  sets,
  reps,
  timer,
  style,
  supersetColor,
}: ExerciseCardProps) => {
  return (
    <Container style={{ ...style }}>
      <View
        style={{
          flexDirection: 'row',
          gap: Spacing.md,
          padding: `${Spacing.md}px ${Spacing.sm}px`,
          borderLeft: `3px solid ${supersetColor}`,
        }}
      >
        <ExerciseImage diameter={64} source={image} />
        <View style={{ justifyContent: 'center', gap: Spacing.sm, flex: 1 }}>
          <TextMD>{title}</TextMD>
          <LinkableText
            text={notes}
            enableLinks
            textStyle={{
              whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere',
              color: colors.neutral500,
            }}
          ></LinkableText>
          {sets || reps || timer ? (
            <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: Spacing.sm }}>
              {sets && <ChicletIndicator title={sets} iconType={'set'} />}
              {reps && <ChicletIndicator title={reps} iconType={'reps'} />}
              {timer && <ChicletIndicator title={timer} iconType={'timer'} />}
            </View>
          ) : (
            <div />
          )}
        </View>
      </View>
    </Container>
  );
};
